import apiClient, { extractData } from "./client";

export async function getInventoryNights(params = {}) {
  const response = await apiClient.get("/inventory-nights", { params });
  return extractData(response);
}

export async function getInventoryNight(id) {
  const response = await apiClient.get(`/inventory-nights/${id}`);
  return extractData(response);
}

export async function createInventoryNight(data) {
  const response = await apiClient.post("/inventory-nights", data);
  return extractData(response);
}

export async function updateInventoryNight(id, data) {
  const response = await apiClient.patch(`/inventory-nights/${id}`, data);
  return extractData(response);
}

export async function recalculateInventoryNight(id) {
  const response = await apiClient.post(`/inventory-nights/${id}/recalculate`);
  return extractData(response);
}

export async function submitInventoryNight(id) {
  const response = await apiClient.post(`/inventory-nights/${id}/submit`);
  return extractData(response);
}

export async function approveInventoryNight(id, data = {}) {
  const response = await apiClient.post(`/inventory-nights/${id}/approve`, data);
  return extractData(response);
}

export async function rejectInventoryNight(id, data = {}) {
  const response = await apiClient.post(`/inventory-nights/${id}/reject`, data);
  return extractData(response);
}

export async function settleInventoryNight(id) {
  const response = await apiClient.post(`/inventory-nights/${id}/settle`);
  return extractData(response);
}

export async function cancelInventoryNight(id) {
  const response = await apiClient.post(`/inventory-nights/${id}/cancel`);
  return extractData(response);
}
